module.exports = __webpack_public_path__ + "boat.svg?4b70165f3e85d0ad36bf2e6d279dae3c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/boat.svg
// module id = 161
// module chunks = 0